// src/utils/priceUtils.js

/**
 * Determines the price unit string (e.g., 'day', 'hour', 'trip', 'person')
 * based on the boat's configuration and a specific slot (optional).
 * 
 * @param {object} boat - The boat object containing configuration flags.
 * @param {object} [selectedSlot] - The specific availability slot being viewed/booked. Defaults to the first slot.
 * @returns {string} The price unit string.
 */
export const getBoatPriceUnit = (boat, selectedSlot = null) => {
  let unit = 'day';
  
  // Use the provided slot, or fall back to the first available slot, or null
  const slot = selectedSlot || (boat.availabilitySlots && boat.availabilitySlots.length > 0 ? boat.availabilitySlots[0] : null);

  if (slot) {
    if (boat.isMultiDay) {
      if (boat.isExcursion) {
        // Multi-day Excursion
        unit = slot.isDateRangeFlexible ? 'day / person' : 'trip / person';
      } else {
        // Multi-day Private Charter
        unit = 'day';
      }
    } else {
      // Single Day / Hourly
      if (slot.isTimeRangeFlexible) {
        unit = 'hour';
        if (boat.isExcursion) unit += ' / person';
      } else {
        // Fixed Slot (Hourly or Excursion)
        unit = boat.isExcursion ? 'person' : 'trip';
      }
    }
  } else {
    // Fallback for legacy data without slots
    if (boat.bookingTimeframe === 'Hourly') unit = 'hour';
    else if (boat.bookingTimeframe === 'Trip') unit = 'trip';
    
    if (boat.isExcursion) unit += ' / person';
  }
  
  return unit;
};
